// Module
var code = `<customer-breadcrumbs mode="'GROUP'"></customer-breadcrumbs>
<customer-profile-header mode="'GROUP'"></customer-profile-header>
<section id="customer-loans" class="box">
  <sub-header header="'Group loans'">
    <div class="right-header-panel">
      <div class="switch">
        <input id="closed-table-switch"
               type="checkbox"
               ng-model="\$ctrl.showClosed"
               ng-click="\$ctrl.toggleClosedLoans()"
               ng-disabled="\$ctrl.onlyClosedLoans()"/>
        <label for="closed-table-switch">Show closed loans</label>
      </div>
    </div>
    <button class="btn btn-primary" command-access="CreateLoanBatch" ng-click="\$ctrl.createNew()">Create new</button>
  </sub-header>
  <customer-group-access></customer-group-access>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active"><a data-target="#group-batch" data-toggle="tab">
        <span>Per Batch</span>
      </a></li>

      <li><a data-target="#group-individual" data-toggle="tab">
        <span>Per Individual</span>
      </a></li>
    </ul>
  </div>


  <div class="tab-content">

    <div class="tab-pane active" id="group-batch">
      <group-loans-batch
          batches="\$ctrl.batches"
          batch="\$ctrl.batch"
          batch-change-action="\$ctrl.onBatchChange"
      ></group-loans-batch>
    </div>

    <div class="tab-pane" id="group-individual">
      <batch-individual-loans batches="\$ctrl.batches"></batch-individual-loans>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/loans/group-loans.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;